// imports
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// local imports
import { mapSlice } from './mapSlice';
import { uiSlice } from './uiSlice';
import waterDataReducer from './waterDataSlice';
import awdConfigApi from '../services/awdConfigApi';
import { awdVizConfigApi } from '../services/awdVizConfigApi';
import alertsApi from '../services/alertsApi';

// create root reducer
const rootReducer = combineReducers({
  map: mapSlice.reducer,
  ui: uiSlice.reducer,
  waterData: waterDataReducer,
  [awdConfigApi.reducerPath]: awdConfigApi.reducer,
  [awdVizConfigApi.reducerPath]: awdVizConfigApi.reducer,
  [alertsApi.reducerPath]: alertsApi.reducer,
});

// configure store function with optional preloaded state for using in testing
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    // RTK query middleware
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        awdConfigApi.middleware,
        awdVizConfigApi.middleware,
        alertsApi.middleware
      ),
  });
};

// initialize store
const store = setupStore();

setupListeners(store.dispatch);
// Export types
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

// Export actions
export const mapActions = mapSlice.actions;
export const uiActions = uiSlice.actions;

export default store;
